// extracted by mini-css-extract-plugin
export default {"Edit":"Edit_Edit__6HhKP"};